export default "__VITE_ASSET__Bh5UBvIi__"